import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./Auth/Login";
import Register from "./Auth/Register";

import { GlobalProvider } from "./Context/GlobalContext";
import Layout from "./Layouts/Layout";
import LayoutDashboard from "./Layouts/LayoutDashboard";
import Dasboard from "./Pages/Dashboard/Dasboard";
import Error from "./Pages/Error/Error";
import Home from "./Pages/Home/Home";
import ListJobVacancy from "./Pages/Jobs/ListJobVacancy.jsx";
import Profile from "./Pages/Profile/Profile";
import FormJobVacancy from "./Pages/Jobs/FormJobVacancy";
import ChangePassword from "./Auth/ChangePassword";
import DetailJob from "./Pages/Jobs/DetailJob";

const RouterComponent = () => {
  return (
    <>
      <BrowserRouter>
        <GlobalProvider>
          <Routes>
            <Route path="*" element={<Error />} />
            <Route
              path="/"
              element={
                <Layout>
                  <Home />
                </Layout>
              }
            />
            <Route
              path="/dashboard"
              element={
                <LayoutDashboard>
                  <Dasboard />
                </LayoutDashboard>
              }
            />
            <Route
              path="/dashboard/list-job-vacancy"
              element={
                <LayoutDashboard>
                  <ListJobVacancy />
                </LayoutDashboard>
              }
            />
            <Route
              path="/dashboard/list-job-vacancy/form"
              element={
                <LayoutDashboard>
                  <FormJobVacancy />
                </LayoutDashboard>
              }
            />
            <Route
              path="/dashboard/list-job-vacancy/detail/:idData"
              element={
                <LayoutDashboard>
                  <DetailJob />
                </LayoutDashboard>
              }
            />
            <Route
              path="dashboard/list-job-vacancy/update/:idData"
              element={
                <LayoutDashboard>
                  <FormJobVacancy />
                </LayoutDashboard>
              }
            />
            <Route
              path="/dashboard/profile"
              element={
                <LayoutDashboard>
                  <Profile />
                </LayoutDashboard>
              }
            />
            <Route
              path="/dashboard/change-password"
              element={
                <LayoutDashboard>
                  <ChangePassword />
                </LayoutDashboard>
              }
            />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
          </Routes>
        </GlobalProvider>
      </BrowserRouter>
    </>
  );
};

export default RouterComponent;
